<template>
<div>
</div>
</template>

<script>
export default {
  props: ['url', 'option'],
  data() {
    return {}
  },
  created: function () {
    let self = this
    setTimeout(function () {
      (self.option == 'text_only') ? self.printTicketViaText() : self.createIframe()
    }, 500);
  },
  methods: {
    createIframe() {
      var printWindow = window.open(this.url, '_blank');
      printWindow.print();
      this.$emit('print', true)
    },
    printTicketViaText() {
      const fileUrl = encodeURIComponent(this.url);
      const deepLink = `ticketprinter://${fileUrl}`;
      window.location.href = deepLink;
      this.$emit('print', true)
    }
  }
}
</script>

<style lang="scss"></style>
